import React, { useEffect, useState } from 'react'
import { Form, Input, Select } from 'antd'
import { Modal } from '@/components/dialog/modal'
import $msg from '@/utils/message'
import { IMemberGroupListItem } from '@/model/types/member'
import { addMemberManual } from '../api'

interface AddMemberForm {
    real_name: string
    phone: string
    card_code?: string
    group_id?: number
}

interface Props {
    visible: boolean
    groups: IMemberGroupListItem[]
    onCancel: () => void
    onSuccess: () => void
}

const AddMemberModal: React.FC<Props> = props => {
    const [form] = Form.useForm<AddMemberForm>()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!props.visible) {
            form.resetFields()
        }
    }, [form, props.visible])

    const onSubmit = async () => {
        try {
            const values = await form.validateFields()
            setLoading(true)
            await addMemberManual({
                real_name: values.real_name,
                phone: values.phone,
                card_code: values.card_code || undefined,
                group_id: values.group_id,
            })
            $msg('success', '添加会员成功')
            props.onSuccess()
        } catch (e) {
            if (e && e.errorFields) return
            $msg('error', e.message || '添加会员失败')
        } finally {
            setLoading(false)
        }
    }

    return props.visible ? (
        <Modal
            title="添加会员"
            isShow
            type="success"
            loading={loading}
            onConfirm={onSubmit}
            onClose={props.onCancel}
            onCancel={props.onCancel}
            okText="确认"
            cancelText="取消"
        >
            <Form form={form} layout="vertical">
                <Form.Item name="real_name" label="会员姓名" rules={[{ required: true, message: '请输入会员姓名' }]}>
                    <Input maxLength={20} placeholder="请输入会员姓名" />
                </Form.Item>
                <Form.Item
                    name="phone"
                    label="手机号"
                    rules={[
                        { required: true, message: '请输入手机号' },
                        { pattern: /^1\d{10}$/, message: '请输入正确的手机号' },
                    ]}
                >
                    <Input placeholder="请输入手机号" maxLength={11} />
                </Form.Item>
                <Form.Item
                    name="card_code"
                    label="会员卡号"
                    rules={[{ pattern: /^\d{4,12}$/, message: '会员卡号需为4-12位数字' }]}
                >
                    <Input maxLength={12} placeholder="请输入会员卡号" />
                </Form.Item>
                <Form.Item name="group_id" label="会员分组">
                    <Select allowClear placeholder="请选择会员分组">
                        {props.groups.map(group => (
                            <Select.Option key={group.id} value={group.id}>
                                {group.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    ) : null
}

export default AddMemberModal
